var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters justify-content-end mb-2"},[_c('a',{staticClass:"btn btn__primary",attrs:{"href":_vm.newAuctionPath}},[_vm._v("\n    "+_vm._s(_vm.I18n.t(("auctions_catalogs.create_" + _vm.auctionType + "_auction")))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db2bfcbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees/auctions_catalogs/index/components/create_auction_button.vue
// module id = 814
// module chunks = 0 1 2 3 4 5 6 7 8 10 82 376